// extracted by mini-css-extract-plugin
export default {"wrapper":"PortalLoader__wrapper__nr6kn","dotContainer":"PortalLoader__dotContainer__Iiad1","dot":"PortalLoader__dot__lKmZD","g-new-wave":"PortalLoader__g-new-wave__Uh8DP"};